<template>
  <div>
    <v-dialog v-model="show" persistent max-width="600px" width="600px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>تعديل الطالب </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <div style="margin-top: 10px"></div>

          <v-text-field v-model="student.studentName" outlined label="اسم الطالب" :rules="studentRequiredFormRules"></v-text-field>

          <v-text-field v-model="student.phone" outlined label=" رقم الهاتف" :rules="studentRequiredFormRules" type="number"></v-text-field>

          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="student.dob" outlined label="تاريخ الميلاد" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="student.dob" @input="menu2 = false"></v-date-picker>
          </v-menu>

          <v-autocomplete v-model="student.gender" outlined label="الجنس" item-text="text" item-value="value" :rules="studentRequiredFormRules" :items="genders" item-color="accent"></v-autocomplete>

          <v-text-field v-model="student.address" outlined label="العنوان" :rules="studentRequiredFormRules"></v-text-field>

          <v-text-field v-model="student.certificate" outlined label=" الشهادة" :rules="studentRequiredFormRules"></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text @click="saveData" color="success" v-on:keyup.enter="saveData"> تعديل </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mx-2" text color="warning" @click="show = true" v-bind="attrs" v-on="on">
          <v-icon dark> mdi-circle-edit-outline </v-icon>
        </v-btn>
      </template>
      <span>تعديل الطالب</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    studentRequiredFormRules: [(v) => !!v || "حقل مطلوب . يرجى ادخال قيمة"],
    show: false,

    menu2: false,

    genders: [
      { text: "ذكر", value: "MALE" },
      { text: "انثى", value: "FEMALE" },
    ],
  }),

  methods: {
    saveData() {
      let self = this;

      this.$http
        .put(
          `${this.$store.state.apiUrlFees}/studentInformation/${self.student.idStudentInformation}`,

          self.student,
          {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }
        )
        .then((res) => {
          this.show = false;
          this.$toasted.success("تم تعديل البيانات");
          this.$emit("reloadTask");
        })
        .catch((err) => {
          this.$toasted.error(" حدث خطأ في البيانات");
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
